export default function(delay, handler) {
  var tid, evt;

  function callback() {
    handler(evt);
    tid = evt = null;
  }

  return function(e) {
    evt = e;
    if (tid) clearTimeout(tid);
    tid = setTimeout(callback, delay);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-util/src/debounce.js
// module id = 1533
// module chunks = 0